import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { workoutService } from "../services/workout";
import { WorkoutLog } from "../schemas/workout";

export function useActivityLogData() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [activityLog, setActivityLog] = useState<WorkoutLog | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchActivityLog() {
      if (!id) return;
      try {
        setIsLoading(true);
        setError(null);
        const data = await workoutService.getWorkoutLog(id);
        if (data.workout_snapshot && typeof data.workout_snapshot === "string") {
          try {
            data.workout_snapshot = JSON.parse(data.workout_snapshot);
          } catch (e) {
            console.error("Error parsing workout_snapshot:", e);
          }
        }
        setActivityLog(data);
      } catch (error: any) {
        console.error("Error fetching activity log:", error);
        setError(error.message);
        toast.error("Failed to load activity log");
      } finally {
        setIsLoading(false);
      }
    }
    fetchActivityLog();
  }, [id]);

  return { isLoading, activityLog, error, navigate, id, setActivityLog };
}
